import { defineComponent, h } from 'vue';
import { QBtn, QIcon } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import VerticalStackContent from './VerticalStackContent.jsx';
import computed from '../../../Shared/computed';

export default defineComponent({
    name: 'stack-vertical-dsgn',
    components: {
        QBtn,
        QIcon,
        VerticalStackContent
    },
    data: function () {
        return {
            items_id: '_0',
            is_vstack_parent: true,
        }
    },
    computed: {
        ...computed,
    },
    mounted() {
    },
    methods: {
        generateBreadCrumbs(h) {
            if (this.controlData.BreadCrumb && this.controlData.BreadCrumb.Text) {
                const crumbs = [];
                crumbs.push(
                    <QBtn flat size="sm" disable>{this.controlData.BreadCrumb.Text}</QBtn>
                );
                crumbs.push(<QIcon name="mdi-chevron-right" size="xs" />);
                return (
                    <div style="display: flex; flex-direction: row;">{crumbs}</div>
                );
            }
            else
                return null;
        },
    },
    props: {
        root: null,
        designmodel: null,
        parentType: null,
        controlData: null,
        sourceData: null,
        type: null,
        asbase: false,
    },
    render() {
        let items_id = this.items_id;

        let controlData = this.controlData;

        const style = {
            overflow: "auto",
            display: "flex",
            flexDirection: "column",
            minWidth: "15px",
            ...utils.getSize(controlData.SizeOptions, this.parentType, this.$parent),
            ...utils.getStyleHints(controlData.StyleHints),
        };

        const breadcrumb = this.generateBreadCrumbs(h);
        
        return (
            <div
                class={{ [`c-${this.type}`]: true, [`c-name-${this.controlData?.Name || 'unnamed'}`]: true }}
                style={style}
                >

                {breadcrumb}
                <VerticalStackContent
                    key={items_id}
                    onFinishedRender={() => this.finishRenderHandler()}
                    designmodel={this.designmodel}
                    type={this.type}
                    name={controlData.Name}
                    root={this.root}
                    parentType={this.parentType}
                    controlData={controlData}
                    sourceData={this.sourceData}
                    asbase={this.asbase}
                >
                </VerticalStackContent>
            </div>
        );
    }
});